import React from "react";
import "./Input.css";

export default function Input(props) {
  const { register, name, validations = {}, errors } = props;

  return (
    <>
      <input
        className={`form-input ${props.className ? props.className : ""}`}
        {...register(name, {
          ...validations,
        })}
        {...props}
      />
      {errors && (
        <p className="text-danger mb-0">{errors.message || errors.type}</p>
      )}
    </>
  );
}
